import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { UiButton } from "../../../_uiComponents/common/UiButton";

export const InvalidDetailsPopup = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <UiPopup
        openModal={props?.isOpen}
        handleClose={() => {
          props?.closeModal(false);
        }}
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("Invalid Debit Card Details")}
          buttonText={t("Ok")}
          buttonOnClick={() => {
            props?.closeModal(false);
          }}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>
            <Trans
              i18nKey={t(
                "It seems like the entered debit card number is not eligible to register for Digital Banking services.",
              )}
            />
            {props?.statusCode && (
              <>
                <br />
                <br />
                {`${t("Error Code")} : ${props.statusCode}`}
              </>
            )}
          </p>
          <p className=" mt-1">{t("For further assistance, please contact")}</p>

          <div className="df-onboarding-alert-customer-support">
            <a
              className="df-primary-underlined-btn df-modal-support-text"
              href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
            >
              {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
            </a>
          </div>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
